import { http } from './config'

export default {

  getAllProducts: () => {
    return http.get('product_location')
  },
  getProductById: (params) => {
    return http.get('products/' + params.id, { params })
  },
  saveSequence: (assembly_sequence, productId) => {
    return http.put('products/' + productId + '/sequence_product', {
      assembly_sequence: assembly_sequence,
    })
  },
  updateProduct: (params) => {
    let formData = new FormData();

    if (params.address != undefined) {
      formData.append('product[address]', params.address);
    }

    if (params.assembly_sequence != undefined) {
      formData.append('product[assembly_sequence]', params.assembly_sequence);
    }
    
    return http.put('products/' + params.id, formData)
  },

}
